import { render } from "./Privacy.vue?vue&type=template&id=3b89ae74"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=3b89ae74&lang=scss"

import exportComponent from "/Users/kurlov/WebstormProjects/2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__